import getApiInstance from 'data/common/ApiCallGenerique';
import { Logger } from 'data/common';
import api from './api';

const apiCaller = getApiInstance();

function getLogsCocoon(fromDate, toDate) {
    return () => {
        return apiCaller
            .call(api.getLogsCocoon(fromDate, toDate))
            .then(result => {
                return result.data;
            })
            .catch(e => {
                Logger.log('dataActions: getLogsCocoon - ', e);
                throw e;
            });
    };
}
export { getLogsCocoon };



// WEBPACK FOOTER //
// ./environments/logging/data/LogsCocoon/actions.js